import { render, staticRenderFns } from "./AppRegisterr.vue?vue&type=template&id=06a71934"
import script from "./AppRegisterr.vue?vue&type=script&lang=js"
export * from "./AppRegisterr.vue?vue&type=script&lang=js"
import style0 from "./AppRegisterr.vue?vue&type=style&index=0&id=06a71934&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports